import React from 'react';
import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from 'recharts';
import { useApp } from '@/context/AppContext';

const scoreColor = (s) => (s >= 75 ? '#10B981' : s >= 55 ? '#F59E0B' : '#EF4444');

export const HealthGauge = ({ score, label, size = 200 }) => {
  const { t } = useApp();
  const color = scoreColor(score);
  const data = [{ value: score, fill: color }];
  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }} data-testid="health-gauge">
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart innerRadius="72%" outerRadius="100%" data={data} startAngle={225} endAngle={-45} barSize={14}>
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
          <RadialBar background={{ fill: '#F1F1F3' }} dataKey="value" cornerRadius={12} angleAxisId={0} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-heading font-bold text-zinc-900 font-mono-num" style={{ fontSize: size * 0.22 }} data-testid="health-score-value">{score}</span>
        <span className="text-xs text-zinc-400 -mt-1">/ 100</span>
        <span className="mt-1 text-xs font-semibold px-2.5 py-0.5 rounded-full" style={{ color, background: `${color}1A` }}>{label}</span>
      </div>
    </div>
  );
};

export const MiniBar = ({ value }) => {
  const color = scoreColor(value);
  return (
    <div className="h-2 w-full rounded-full bg-zinc-100 overflow-hidden">
      <div className="h-full rounded-full transition-all" style={{ width: `${value}%`, background: color }} />
    </div>
  );
};
